// extracted by mini-css-extract-plugin
export default {"chip":"chip_chip__tpnlG","chipFunded":"chip_chipFunded__IUKao","chipLabel":"chip_chipLabel__N1mPO"};